import { createSlice } from '@reduxjs/toolkit';

const levelsSlice = createSlice({
  name: 'levels',
  initialState: {
    data: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    fetchLevelsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLevelsSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      state.lastFetched = Date.now();
    },
    fetchLevelsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchLevelsStart, fetchLevelsSuccess, fetchLevelsFailure } = levelsSlice.actions;
export default levelsSlice.reducer;
